import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {Upload} from "../../dto/upload";
import {DataListModel} from "../../models/data-list-model";
import {CrudService} from "../../services";
import {ViewService} from "../../services/crud/interfaces/view-service.interface";

@Injectable({
  providedIn: 'root'
})
export class UploadsAdminService implements ViewService<Upload> {
  readonly apiPath = 'uploads-admin/';

  constructor(private http: HttpClient) {
  }

  get(fileName: string, albumId: string) {
    const params = new HttpParams()
      .set('fileName', fileName)
      .set('albumId', albumId)
    ;
    return this.http.get(this.apiPath + "detail", {params}) as Observable<Upload>;
  }

  getAlbums() {
    return this.http.get(this.apiPath + 'albums') as Observable<string[]>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string, // someadditionaldata
  ): Observable<DataListModel<Upload>> {
    const params = new HttpParams()
      .set('page',            pageIndex.toString())
      .set('pageSize',        pageSize.toString())
      .set('filterString',    filterString)
      .set('sortField',       sortField)
      .set('sortDirection',   sortDirection);
    return this.http.get(this.apiPath + 'album/' + someAdditionalData, { params }) as Observable<DataListModel<Upload>>;
  }


  getById(uploadId: number) {
    return this.http.get(this.apiPath + 'by-id/' + uploadId) as Observable<Upload>;
  }

  uploadFile( item: File, albumId: string ): Observable<Upload> {
    const params = new HttpParams()
      .set('albumId', albumId)
    ;

    const data = new FormData();
    data.append( 'f', item, item.name );
    return this.http.post( this.apiPath + 'upload-file', data, {params} ) as Observable<Upload>;
  }

}
